import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const PlainButton = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <button
      aria-label={props["aria-label"] || props.title}
      className={classNames("et--plain-button", className)}
      ref={ref}
      {...props}
    />
  );
});

PlainButton.propTypes = {
  className: PropTypes.string,
};

export default PlainButton;
